// extracted by mini-css-extract-plugin
module.exports = {"sort":"SortControl-module__sort___sM4gJ","sort-sizing":"SortControl-module__sort-sizing___3Stzq"};